// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v3.12.4
// source: brain_sensor_msgs.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { PoseWithCovariance } from "./geometry_msgs";
import { PointField } from "./sensor_msgs";
import { Header } from "./std_msgs";

export const protobufPackage = "brain_sensor_msgs.proto";

export interface AccessoryInfo {
  header: Header | undefined;
  turnSignalStatus: AccessoryInfo_TurnSignalStatus;
  doorLeftStatus: AccessoryInfo_DoorStatus;
  doorRightStatus: AccessoryInfo_DoorStatus;
  trunkDoorStatus: AccessoryInfo_DoorStatus;
  doorLock: AccessoryInfo_DoorLockStatus;
  override: AccessoryInfo_OverrideStatus;
  controlState: number;
  errorCode: number;
  actuationMode: AccessoryInfo_ActuationMode;
}

export enum AccessoryInfo_TurnSignalStatus {
  INVALID = 0,
  LEFT = 1,
  RIGHT = 2,
  HAZARD = 3,
  UNRECOGNIZED = -1,
}

export enum AccessoryInfo_DoorStatus {
  DOOR_INACTIVE = 0,
  DOOR_CLOSED = 1,
  DOOR_OPENED = 2,
  UNRECOGNIZED = -1,
}

export enum AccessoryInfo_DoorLockStatus {
  DOOR_LOCK_INACTIVE = 0,
  DOOR_LOCK = 1,
  DOOR_UNLOCK = 2,
  UNRECOGNIZED = -1,
}

export enum AccessoryInfo_OverrideStatus {
  INACTIVE = 0,
  OVERRIDE = 1,
  UNRECOGNIZED = -1,
}

export enum AccessoryInfo_ActuationMode {
  ACTUATION_NA = 0,
  ACTUATION_ACTUATOR = 1,
  ACTUATION_EMULATION = 2,
  UNRECOGNIZED = -1,
}

export interface AccessoryState {
  header: Header | undefined;
  turnSignalStatus: AccessoryState_TurnSignalStatus;
  doorLeftStatus: AccessoryState_DoorStatus;
  doorRightStatus: AccessoryState_DoorStatus;
  doorLock: AccessoryState_DoorLockStatus;
}

export enum AccessoryState_TurnSignalStatus {
  INVALID = 0,
  LEFT = 1,
  RIGHT = 2,
  HAZARD = 3,
  UNRECOGNIZED = -1,
}

export enum AccessoryState_DoorStatus {
  DOOR_INACTIVE = 0,
  DOOR_CLOSED = 1,
  DOOR_OPENED = 2,
  UNRECOGNIZED = -1,
}

export enum AccessoryState_DoorLockStatus {
  DOOR_LOCK_INACTIVE = 0,
  DOOR_LOCK = 1,
  DOOR_UNLOCK = 2,
  UNRECOGNIZED = -1,
}

export interface ChargingInfo {
  header: Header | undefined;
  chargeState: number;
  chargeDoorStatus: ChargingInfo_DoorStatus;
  connectedStatus: ChargingInfo_ConnectionStatus;
  chargingStatus: ChargingInfo_ChargingStatus;
  estimateTime: number;
}

export enum ChargingInfo_DoorStatus {
  DOOR_UNKNOWN = 0,
  DOOR_CLOSED = 1,
  DOOR_OPEN = 2,
  UNRECOGNIZED = -1,
}

export enum ChargingInfo_ConnectionStatus {
  CONNECTION_UNKNOWN = 0,
  DISCONNECTED = 1,
  CONNECTED = 2,
  UNRECOGNIZED = -1,
}

export enum ChargingInfo_ChargingStatus {
  CHARGING_UNKNOWN = 0,
  UNCHARGING = 1,
  CHARGING = 2,
  UNRECOGNIZED = -1,
}

export interface CompressedPointCloud {
  header: Header | undefined;
  height: number;
  width: number;
  fields: PointField[];
  compressedData: Uint8Array;
  isBigendian: boolean;
  pointStep: number;
  rowStep: number;
  isDense: boolean;
  device: string;
  channel: number;
}

export interface ConfigInfo {
  header: Header | undefined;
  ecuId: number;
  function: number;
  value: number;
}

export enum ConfigInfo_ResponseCode {
  RES_NA = 0,
  RES_SUCCESS = 1,
  RES_FAILED = 2,
  UNRECOGNIZED = -1,
}

export interface DynamicInfo {
  header: Header | undefined;
  vehicleSpeed: number;
  lateralAcceleration: number;
  longitudinalAcceleration: number;
  rollRate: number;
  pitchRate: number;
  yawRate: number;
}

export interface DynamicState {
  header: Header | undefined;
  vehicleSpeed: number;
  lateralAcceleration: number;
  longitudinalAcceleration: number;
  rollRate: number;
  pitchRate: number;
  yawRate: number;
}

export interface FreespacePoint {
  distance: number;
  yaw: number;
  probability: number;
}

export interface Freespace {
  header: Header | undefined;
  points: FreespacePoint[];
}

export interface GearInfo {
  header: Header | undefined;
  gearStatus: GearInfo_GearStatus;
  controlState: number;
  override: GearInfo_OverrideStatus;
  errorCode: number;
  actuationMode: GearInfo_ActuationMode;
  mrmStatus: GearInfo_MrmStatus;
}

export enum GearInfo_GearStatus {
  INACTIVE = 0,
  GEAR_P = 1,
  GEAR_R = 2,
  GEAR_N = 3,
  GEAR_D = 4,
  UNRECOGNIZED = -1,
}

export enum GearInfo_OverrideStatus {
  /** OVERRIDE_INACTIVE - Renamed */
  OVERRIDE_INACTIVE = 0,
  OVERRIDE = 1,
  UNRECOGNIZED = -1,
}

export enum GearInfo_ActuationMode {
  ACTUATION_NA = 0,
  ACTUATION_ACTUATOR = 1,
  ACTUATION_EMULATION = 2,
  UNRECOGNIZED = -1,
}

export enum GearInfo_MrmStatus {
  MRM_NA = 0,
  MRM_STANDALONE = 1,
  MRM_COOPERATIVE = 2,
  MRM_FAULT = 3,
  UNRECOGNIZED = -1,
}

/** This was an empty message in the original set, so it remains empty. */
export interface GearState {
}

export interface IgnitionInfo {
  header: Header | undefined;
  status: IgnitionInfo_Status;
}

export enum IgnitionInfo_Status {
  UNKNOWN = 0,
  OFF = 1,
  ACC = 2,
  START = 3,
  DRIVE = 4,
  UNRECOGNIZED = -1,
}

export interface LongitudinalInfo {
  header: Header | undefined;
  motorRpm: number;
  accelerationPedalPos: number;
  brakePedalPos: number;
  controlState: number;
  override: LongitudinalInfo_OverrideStatus;
  actuatorStatus: number;
  errorCode: number;
  responseTimeAcc: number;
  responseTimeBrk: number;
  actuationMode: LongitudinalInfo_ActuationMode;
  mrmStatus: LongitudinalInfo_MrmStatus;
}

export enum LongitudinalInfo_OverrideStatus {
  INACTIVE = 0,
  ACCEL_PEDAL_OVERRIDE = 1,
  BRAKE_PEDAL_OVERRIDE = 2,
  BOTH_PEDAL_OVERRIDE = 3,
  UNRECOGNIZED = -1,
}

export enum LongitudinalInfo_ActuationMode {
  ACTUATION_NA = 0,
  ACTUATION_ACTUATOR = 1,
  ACTUATION_EMULATION = 2,
  UNRECOGNIZED = -1,
}

export enum LongitudinalInfo_MrmStatus {
  MRM_NA = 0,
  MRM_STANDALONE = 1,
  MRM_COOPERATIVE = 2,
  MRM_FAULT = 3,
  UNRECOGNIZED = -1,
}

export interface LongitudinalState {
  header: Header | undefined;
  brakePedalStatus: LongitudinalState_BrakePedalStatus;
  accelerationPedalStatus: LongitudinalState_AccelPedalStatus;
}

export enum LongitudinalState_BrakePedalStatus {
  BRAKE_INACTIVE = 0,
  BRAKE_PEDAL_RELEASED = 1,
  BRAKE_PEDAL_PUSHED = 2,
  UNRECOGNIZED = -1,
}

export enum LongitudinalState_AccelPedalStatus {
  ACCEL_INACTIVE = 0,
  ACCEL_PEDAL_RELEASED = 1,
  ACCEL_PEDAL_PUSHED = 2,
  UNRECOGNIZED = -1,
}

export interface PositioningInfo {
  header: Header | undefined;
  latitude: number;
  longitude: number;
  height: number;
  quality: number;
  heading: number;
  pitch: number;
  roll: number;
}

export interface SteeringInfo {
  header: Header | undefined;
  steeringOverride: SteeringInfo_SteeringOverride;
  steeringTorque: number;
  steeringAngle: number;
  steeringAngleRate: number;
  steeringOffset: number;
  controlState: number;
  actuatorStatus: number;
  errorCode: number;
  responseTime: number;
  actuationMode: SteeringInfo_ActuationMode;
  mrmStatus: SteeringInfo_MrmStatus;
}

export enum SteeringInfo_SteeringOverride {
  INACTIVE = 0,
  STEERING_NOT_OVERRIDE = 1,
  STEERING_OVERRIDE = 2,
  UNRECOGNIZED = -1,
}

export enum SteeringInfo_ActuationMode {
  ACTUATION_NA = 0,
  ACTUATION_ACTUATOR = 1,
  ACTUATION_EMULATION = 2,
  UNRECOGNIZED = -1,
}

export enum SteeringInfo_MrmStatus {
  MRM_NA = 0,
  MRM_STANDALONE = 1,
  MRM_COOPERATIVE = 2,
  MRM_FAULT = 3,
  UNRECOGNIZED = -1,
}

export interface SteeringState {
  header: Header | undefined;
  steeringOverride: SteeringState_SteeringOverride;
  steeringTorque: number;
  steeringAngle: number;
  steeringAngleRate: number;
}

export enum SteeringState_SteeringOverride {
  INACTIVE = 0,
  STEERING_NOT_OVERRIDE = 1,
  STEERING_OVERRIDE = 2,
  UNRECOGNIZED = -1,
}

export interface TimeInfo {
  header: Header | undefined;
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
  second: number;
  millisecond: number;
}

export interface TrafficLight {
  header: Header | undefined;
  state: TrafficLight_State;
  stateProbability: number;
  type: TrafficLight_Type;
  isIts: boolean;
  intersectionId: number;
  groupId: number;
  endTime: number;
  perceptionLevel: TrafficLight_PerceptionLevel;
  trackId: number;
  pose: PoseWithCovariance | undefined;
}

export enum TrafficLight_State {
  UNKNOWN = 0,
  RED = 1,
  YELLOW = 2,
  GREEN = 3,
  GREEN_LEFT = 4,
  RED_LEFT = 5,
  UNRECOGNIZED = -1,
}

export enum TrafficLight_Type {
  /** TYPE_UNKNOWN - Renamed */
  TYPE_UNKNOWN = 0,
  STR = 1,
  LEFT = 2,
  PED = 3,
  UTURN = 4,
  UNRECOGNIZED = -1,
}

export enum TrafficLight_PerceptionLevel {
  DETECTION = 0,
  TRACKING = 1,
  UNRECOGNIZED = -1,
}

export interface TrafficLightArray {
  trafficLights: TrafficLight[];
}

export interface TrafficSign {
  header: Header | undefined;
  speedLimit: number;
  schoolZone: boolean;
  tollgateLane: boolean;
  coneDetection: boolean;
}

export interface UserConfiguration {
  header: Header | undefined;
  maxSpeed: number;
  maxSteeringTorque: number;
  maxAcceleration: number;
  maxDeceleration: number;
  maxJerk: number;
}

export interface VehicleGenericInfo {
  header: Header | undefined;
  carType: VehicleGenericInfo_CarType;
  plateNumber: string;
  fuelType: VehicleGenericInfo_FuelType;
  fuelState: number;
  mileage: number;
  projectCode: string;
  optionalCode: number;
  licenseKey: string;
}

export enum VehicleGenericInfo_CarType {
  CAR_UNKNOWN = 0,
  CAR_PASSENGER_CAR = 1,
  CAR_VAN = 2,
  CAR_TRUCK = 3,
  CAR_BUS = 4,
  CAR_SPECIAL_PURPOSE = 5,
  UNRECOGNIZED = -1,
}

export enum VehicleGenericInfo_FuelType {
  FUEL_UNKNOWN = 0,
  /** FUEL_GASOLINE - Corrected from 0 */
  FUEL_GASOLINE = 1,
  /** FUEL_DIESEL - Corrected from 0 */
  FUEL_DIESEL = 2,
  /** FUEL_ELECTRIC - Corrected from 0 */
  FUEL_ELECTRIC = 3,
  UNRECOGNIZED = -1,
}

export interface WheelInfo {
  header: Header | undefined;
  wheelSpeedRr: number;
  wheelSpeedRl: number;
  wheelSpeedFr: number;
  wheelSpeedFl: number;
  wheelPulseStatusRr: boolean;
  wheelPulseStatusRl: boolean;
  wheelPulseStatusFr: boolean;
  wheelPulseStatusFl: boolean;
  wheelPulseRr: number;
  wheelPulseRl: number;
  wheelPulseFr: number;
  wheelPulseFl: number;
  wheelDirRr: WheelInfo_WheelDir;
  wheelDirRl: WheelInfo_WheelDir;
  wheelDirFr: WheelInfo_WheelDir;
  wheelDirFl: WheelInfo_WheelDir;
}

export enum WheelInfo_WheelDir {
  FORWARD = 0,
  BACKWARD = 1,
  UNRECOGNIZED = -1,
}

export interface WheelState {
  header: Header | undefined;
  wheelSpeedRr: number;
  wheelSpeedRl: number;
  wheelSpeedFr: number;
  wheelSpeedFl: number;
  wheelPulseStatusRr: boolean;
  wheelPulseStatusRl: boolean;
  wheelPulseStatusFr: boolean;
  wheelPulseStatusFl: boolean;
  wheelPulseRr: number;
  wheelPulseRl: number;
  wheelPulseFr: number;
  wheelPulseFl: number;
  wheelDirRr: WheelState_WheelDir;
  wheelDirRl: WheelState_WheelDir;
  wheelDirFr: WheelState_WheelDir;
  wheelDirFl: WheelState_WheelDir;
}

export enum WheelState_WheelDir {
  FORWARD = 0,
  BACKWARD = 1,
  UNRECOGNIZED = -1,
}

function createBaseAccessoryInfo(): AccessoryInfo {
  return {
    header: undefined,
    turnSignalStatus: 0,
    doorLeftStatus: 0,
    doorRightStatus: 0,
    trunkDoorStatus: 0,
    doorLock: 0,
    override: 0,
    controlState: 0,
    errorCode: 0,
    actuationMode: 0,
  };
}

export const AccessoryInfo: MessageFns<AccessoryInfo> = {
  encode(message: AccessoryInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.turnSignalStatus !== 0) {
      writer.uint32(16).int32(message.turnSignalStatus);
    }
    if (message.doorLeftStatus !== 0) {
      writer.uint32(24).int32(message.doorLeftStatus);
    }
    if (message.doorRightStatus !== 0) {
      writer.uint32(32).int32(message.doorRightStatus);
    }
    if (message.trunkDoorStatus !== 0) {
      writer.uint32(40).int32(message.trunkDoorStatus);
    }
    if (message.doorLock !== 0) {
      writer.uint32(48).int32(message.doorLock);
    }
    if (message.override !== 0) {
      writer.uint32(56).int32(message.override);
    }
    if (message.controlState !== 0) {
      writer.uint32(64).uint32(message.controlState);
    }
    if (message.errorCode !== 0) {
      writer.uint32(72).uint32(message.errorCode);
    }
    if (message.actuationMode !== 0) {
      writer.uint32(80).int32(message.actuationMode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccessoryInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccessoryInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.turnSignalStatus = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.doorLeftStatus = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.doorRightStatus = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.trunkDoorStatus = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.doorLock = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.override = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.controlState = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.errorCode = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.actuationMode = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<AccessoryInfo>, I>>(base?: I): AccessoryInfo {
    return AccessoryInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AccessoryInfo>, I>>(object: I): AccessoryInfo {
    const message = createBaseAccessoryInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.turnSignalStatus = object.turnSignalStatus ?? 0;
    message.doorLeftStatus = object.doorLeftStatus ?? 0;
    message.doorRightStatus = object.doorRightStatus ?? 0;
    message.trunkDoorStatus = object.trunkDoorStatus ?? 0;
    message.doorLock = object.doorLock ?? 0;
    message.override = object.override ?? 0;
    message.controlState = object.controlState ?? 0;
    message.errorCode = object.errorCode ?? 0;
    message.actuationMode = object.actuationMode ?? 0;
    return message;
  },
};

function createBaseAccessoryState(): AccessoryState {
  return { header: undefined, turnSignalStatus: 0, doorLeftStatus: 0, doorRightStatus: 0, doorLock: 0 };
}

export const AccessoryState: MessageFns<AccessoryState> = {
  encode(message: AccessoryState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.turnSignalStatus !== 0) {
      writer.uint32(16).int32(message.turnSignalStatus);
    }
    if (message.doorLeftStatus !== 0) {
      writer.uint32(24).int32(message.doorLeftStatus);
    }
    if (message.doorRightStatus !== 0) {
      writer.uint32(32).int32(message.doorRightStatus);
    }
    if (message.doorLock !== 0) {
      writer.uint32(40).int32(message.doorLock);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccessoryState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccessoryState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.turnSignalStatus = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.doorLeftStatus = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.doorRightStatus = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.doorLock = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<AccessoryState>, I>>(base?: I): AccessoryState {
    return AccessoryState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AccessoryState>, I>>(object: I): AccessoryState {
    const message = createBaseAccessoryState();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.turnSignalStatus = object.turnSignalStatus ?? 0;
    message.doorLeftStatus = object.doorLeftStatus ?? 0;
    message.doorRightStatus = object.doorRightStatus ?? 0;
    message.doorLock = object.doorLock ?? 0;
    return message;
  },
};

function createBaseChargingInfo(): ChargingInfo {
  return {
    header: undefined,
    chargeState: 0,
    chargeDoorStatus: 0,
    connectedStatus: 0,
    chargingStatus: 0,
    estimateTime: 0,
  };
}

export const ChargingInfo: MessageFns<ChargingInfo> = {
  encode(message: ChargingInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.chargeState !== 0) {
      writer.uint32(21).float(message.chargeState);
    }
    if (message.chargeDoorStatus !== 0) {
      writer.uint32(24).int32(message.chargeDoorStatus);
    }
    if (message.connectedStatus !== 0) {
      writer.uint32(32).int32(message.connectedStatus);
    }
    if (message.chargingStatus !== 0) {
      writer.uint32(40).int32(message.chargingStatus);
    }
    if (message.estimateTime !== 0) {
      writer.uint32(53).float(message.estimateTime);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChargingInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChargingInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.chargeState = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.chargeDoorStatus = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.connectedStatus = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.chargingStatus = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.estimateTime = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ChargingInfo>, I>>(base?: I): ChargingInfo {
    return ChargingInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChargingInfo>, I>>(object: I): ChargingInfo {
    const message = createBaseChargingInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.chargeState = object.chargeState ?? 0;
    message.chargeDoorStatus = object.chargeDoorStatus ?? 0;
    message.connectedStatus = object.connectedStatus ?? 0;
    message.chargingStatus = object.chargingStatus ?? 0;
    message.estimateTime = object.estimateTime ?? 0;
    return message;
  },
};

function createBaseCompressedPointCloud(): CompressedPointCloud {
  return {
    header: undefined,
    height: 0,
    width: 0,
    fields: [],
    compressedData: new Uint8Array(0),
    isBigendian: false,
    pointStep: 0,
    rowStep: 0,
    isDense: false,
    device: "",
    channel: 0,
  };
}

export const CompressedPointCloud: MessageFns<CompressedPointCloud> = {
  encode(message: CompressedPointCloud, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.height !== 0) {
      writer.uint32(16).uint32(message.height);
    }
    if (message.width !== 0) {
      writer.uint32(24).uint32(message.width);
    }
    for (const v of message.fields) {
      PointField.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.compressedData.length !== 0) {
      writer.uint32(42).bytes(message.compressedData);
    }
    if (message.isBigendian !== false) {
      writer.uint32(48).bool(message.isBigendian);
    }
    if (message.pointStep !== 0) {
      writer.uint32(56).uint32(message.pointStep);
    }
    if (message.rowStep !== 0) {
      writer.uint32(64).uint32(message.rowStep);
    }
    if (message.isDense !== false) {
      writer.uint32(72).bool(message.isDense);
    }
    if (message.device !== "") {
      writer.uint32(82).string(message.device);
    }
    if (message.channel !== 0) {
      writer.uint32(88).uint32(message.channel);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompressedPointCloud {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompressedPointCloud();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.height = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.width = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fields.push(PointField.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.compressedData = reader.bytes();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isBigendian = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.pointStep = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.rowStep = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.isDense = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.device = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.channel = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CompressedPointCloud>, I>>(base?: I): CompressedPointCloud {
    return CompressedPointCloud.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompressedPointCloud>, I>>(object: I): CompressedPointCloud {
    const message = createBaseCompressedPointCloud();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.height = object.height ?? 0;
    message.width = object.width ?? 0;
    message.fields = object.fields?.map((e) => PointField.fromPartial(e)) || [];
    message.compressedData = object.compressedData ?? new Uint8Array(0);
    message.isBigendian = object.isBigendian ?? false;
    message.pointStep = object.pointStep ?? 0;
    message.rowStep = object.rowStep ?? 0;
    message.isDense = object.isDense ?? false;
    message.device = object.device ?? "";
    message.channel = object.channel ?? 0;
    return message;
  },
};

function createBaseConfigInfo(): ConfigInfo {
  return { header: undefined, ecuId: 0, function: 0, value: 0 };
}

export const ConfigInfo: MessageFns<ConfigInfo> = {
  encode(message: ConfigInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.ecuId !== 0) {
      writer.uint32(16).uint32(message.ecuId);
    }
    if (message.function !== 0) {
      writer.uint32(24).uint32(message.function);
    }
    if (message.value !== 0) {
      writer.uint32(37).float(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfigInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.ecuId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.function = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.value = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ConfigInfo>, I>>(base?: I): ConfigInfo {
    return ConfigInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigInfo>, I>>(object: I): ConfigInfo {
    const message = createBaseConfigInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.ecuId = object.ecuId ?? 0;
    message.function = object.function ?? 0;
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseDynamicInfo(): DynamicInfo {
  return {
    header: undefined,
    vehicleSpeed: 0,
    lateralAcceleration: 0,
    longitudinalAcceleration: 0,
    rollRate: 0,
    pitchRate: 0,
    yawRate: 0,
  };
}

export const DynamicInfo: MessageFns<DynamicInfo> = {
  encode(message: DynamicInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.vehicleSpeed !== 0) {
      writer.uint32(21).float(message.vehicleSpeed);
    }
    if (message.lateralAcceleration !== 0) {
      writer.uint32(29).float(message.lateralAcceleration);
    }
    if (message.longitudinalAcceleration !== 0) {
      writer.uint32(37).float(message.longitudinalAcceleration);
    }
    if (message.rollRate !== 0) {
      writer.uint32(45).float(message.rollRate);
    }
    if (message.pitchRate !== 0) {
      writer.uint32(53).float(message.pitchRate);
    }
    if (message.yawRate !== 0) {
      writer.uint32(61).float(message.yawRate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DynamicInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDynamicInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.vehicleSpeed = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.lateralAcceleration = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.longitudinalAcceleration = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.rollRate = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.pitchRate = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.yawRate = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<DynamicInfo>, I>>(base?: I): DynamicInfo {
    return DynamicInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DynamicInfo>, I>>(object: I): DynamicInfo {
    const message = createBaseDynamicInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.vehicleSpeed = object.vehicleSpeed ?? 0;
    message.lateralAcceleration = object.lateralAcceleration ?? 0;
    message.longitudinalAcceleration = object.longitudinalAcceleration ?? 0;
    message.rollRate = object.rollRate ?? 0;
    message.pitchRate = object.pitchRate ?? 0;
    message.yawRate = object.yawRate ?? 0;
    return message;
  },
};

function createBaseDynamicState(): DynamicState {
  return {
    header: undefined,
    vehicleSpeed: 0,
    lateralAcceleration: 0,
    longitudinalAcceleration: 0,
    rollRate: 0,
    pitchRate: 0,
    yawRate: 0,
  };
}

export const DynamicState: MessageFns<DynamicState> = {
  encode(message: DynamicState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.vehicleSpeed !== 0) {
      writer.uint32(21).float(message.vehicleSpeed);
    }
    if (message.lateralAcceleration !== 0) {
      writer.uint32(29).float(message.lateralAcceleration);
    }
    if (message.longitudinalAcceleration !== 0) {
      writer.uint32(37).float(message.longitudinalAcceleration);
    }
    if (message.rollRate !== 0) {
      writer.uint32(45).float(message.rollRate);
    }
    if (message.pitchRate !== 0) {
      writer.uint32(53).float(message.pitchRate);
    }
    if (message.yawRate !== 0) {
      writer.uint32(61).float(message.yawRate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DynamicState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDynamicState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.vehicleSpeed = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.lateralAcceleration = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.longitudinalAcceleration = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.rollRate = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.pitchRate = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.yawRate = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<DynamicState>, I>>(base?: I): DynamicState {
    return DynamicState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DynamicState>, I>>(object: I): DynamicState {
    const message = createBaseDynamicState();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.vehicleSpeed = object.vehicleSpeed ?? 0;
    message.lateralAcceleration = object.lateralAcceleration ?? 0;
    message.longitudinalAcceleration = object.longitudinalAcceleration ?? 0;
    message.rollRate = object.rollRate ?? 0;
    message.pitchRate = object.pitchRate ?? 0;
    message.yawRate = object.yawRate ?? 0;
    return message;
  },
};

function createBaseFreespacePoint(): FreespacePoint {
  return { distance: 0, yaw: 0, probability: 0 };
}

export const FreespacePoint: MessageFns<FreespacePoint> = {
  encode(message: FreespacePoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.distance !== 0) {
      writer.uint32(13).float(message.distance);
    }
    if (message.yaw !== 0) {
      writer.uint32(21).float(message.yaw);
    }
    if (message.probability !== 0) {
      writer.uint32(29).float(message.probability);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FreespacePoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFreespacePoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.distance = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.yaw = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.probability = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<FreespacePoint>, I>>(base?: I): FreespacePoint {
    return FreespacePoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FreespacePoint>, I>>(object: I): FreespacePoint {
    const message = createBaseFreespacePoint();
    message.distance = object.distance ?? 0;
    message.yaw = object.yaw ?? 0;
    message.probability = object.probability ?? 0;
    return message;
  },
};

function createBaseFreespace(): Freespace {
  return { header: undefined, points: [] };
}

export const Freespace: MessageFns<Freespace> = {
  encode(message: Freespace, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.points) {
      FreespacePoint.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Freespace {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFreespace();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.points.push(FreespacePoint.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Freespace>, I>>(base?: I): Freespace {
    return Freespace.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Freespace>, I>>(object: I): Freespace {
    const message = createBaseFreespace();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.points = object.points?.map((e) => FreespacePoint.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGearInfo(): GearInfo {
  return {
    header: undefined,
    gearStatus: 0,
    controlState: 0,
    override: 0,
    errorCode: 0,
    actuationMode: 0,
    mrmStatus: 0,
  };
}

export const GearInfo: MessageFns<GearInfo> = {
  encode(message: GearInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.gearStatus !== 0) {
      writer.uint32(16).int32(message.gearStatus);
    }
    if (message.controlState !== 0) {
      writer.uint32(24).uint32(message.controlState);
    }
    if (message.override !== 0) {
      writer.uint32(32).int32(message.override);
    }
    if (message.errorCode !== 0) {
      writer.uint32(40).uint32(message.errorCode);
    }
    if (message.actuationMode !== 0) {
      writer.uint32(48).int32(message.actuationMode);
    }
    if (message.mrmStatus !== 0) {
      writer.uint32(56).int32(message.mrmStatus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GearInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGearInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.gearStatus = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.controlState = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.override = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.errorCode = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.actuationMode = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.mrmStatus = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<GearInfo>, I>>(base?: I): GearInfo {
    return GearInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GearInfo>, I>>(object: I): GearInfo {
    const message = createBaseGearInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.gearStatus = object.gearStatus ?? 0;
    message.controlState = object.controlState ?? 0;
    message.override = object.override ?? 0;
    message.errorCode = object.errorCode ?? 0;
    message.actuationMode = object.actuationMode ?? 0;
    message.mrmStatus = object.mrmStatus ?? 0;
    return message;
  },
};

function createBaseGearState(): GearState {
  return {};
}

export const GearState: MessageFns<GearState> = {
  encode(_: GearState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GearState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGearState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<GearState>, I>>(base?: I): GearState {
    return GearState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GearState>, I>>(_: I): GearState {
    const message = createBaseGearState();
    return message;
  },
};

function createBaseIgnitionInfo(): IgnitionInfo {
  return { header: undefined, status: 0 };
}

export const IgnitionInfo: MessageFns<IgnitionInfo> = {
  encode(message: IgnitionInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IgnitionInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIgnitionInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<IgnitionInfo>, I>>(base?: I): IgnitionInfo {
    return IgnitionInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IgnitionInfo>, I>>(object: I): IgnitionInfo {
    const message = createBaseIgnitionInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseLongitudinalInfo(): LongitudinalInfo {
  return {
    header: undefined,
    motorRpm: 0,
    accelerationPedalPos: 0,
    brakePedalPos: 0,
    controlState: 0,
    override: 0,
    actuatorStatus: 0,
    errorCode: 0,
    responseTimeAcc: 0,
    responseTimeBrk: 0,
    actuationMode: 0,
    mrmStatus: 0,
  };
}

export const LongitudinalInfo: MessageFns<LongitudinalInfo> = {
  encode(message: LongitudinalInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.motorRpm !== 0) {
      writer.uint32(16).uint32(message.motorRpm);
    }
    if (message.accelerationPedalPos !== 0) {
      writer.uint32(29).float(message.accelerationPedalPos);
    }
    if (message.brakePedalPos !== 0) {
      writer.uint32(37).float(message.brakePedalPos);
    }
    if (message.controlState !== 0) {
      writer.uint32(40).uint32(message.controlState);
    }
    if (message.override !== 0) {
      writer.uint32(48).int32(message.override);
    }
    if (message.actuatorStatus !== 0) {
      writer.uint32(56).uint32(message.actuatorStatus);
    }
    if (message.errorCode !== 0) {
      writer.uint32(64).uint32(message.errorCode);
    }
    if (message.responseTimeAcc !== 0) {
      writer.uint32(77).float(message.responseTimeAcc);
    }
    if (message.responseTimeBrk !== 0) {
      writer.uint32(85).float(message.responseTimeBrk);
    }
    if (message.actuationMode !== 0) {
      writer.uint32(88).int32(message.actuationMode);
    }
    if (message.mrmStatus !== 0) {
      writer.uint32(96).int32(message.mrmStatus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LongitudinalInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLongitudinalInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.motorRpm = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.accelerationPedalPos = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.brakePedalPos = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.controlState = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.override = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.actuatorStatus = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.errorCode = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.responseTimeAcc = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.responseTimeBrk = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.actuationMode = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.mrmStatus = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<LongitudinalInfo>, I>>(base?: I): LongitudinalInfo {
    return LongitudinalInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LongitudinalInfo>, I>>(object: I): LongitudinalInfo {
    const message = createBaseLongitudinalInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.motorRpm = object.motorRpm ?? 0;
    message.accelerationPedalPos = object.accelerationPedalPos ?? 0;
    message.brakePedalPos = object.brakePedalPos ?? 0;
    message.controlState = object.controlState ?? 0;
    message.override = object.override ?? 0;
    message.actuatorStatus = object.actuatorStatus ?? 0;
    message.errorCode = object.errorCode ?? 0;
    message.responseTimeAcc = object.responseTimeAcc ?? 0;
    message.responseTimeBrk = object.responseTimeBrk ?? 0;
    message.actuationMode = object.actuationMode ?? 0;
    message.mrmStatus = object.mrmStatus ?? 0;
    return message;
  },
};

function createBaseLongitudinalState(): LongitudinalState {
  return { header: undefined, brakePedalStatus: 0, accelerationPedalStatus: 0 };
}

export const LongitudinalState: MessageFns<LongitudinalState> = {
  encode(message: LongitudinalState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.brakePedalStatus !== 0) {
      writer.uint32(16).int32(message.brakePedalStatus);
    }
    if (message.accelerationPedalStatus !== 0) {
      writer.uint32(24).int32(message.accelerationPedalStatus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LongitudinalState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLongitudinalState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.brakePedalStatus = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.accelerationPedalStatus = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<LongitudinalState>, I>>(base?: I): LongitudinalState {
    return LongitudinalState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LongitudinalState>, I>>(object: I): LongitudinalState {
    const message = createBaseLongitudinalState();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.brakePedalStatus = object.brakePedalStatus ?? 0;
    message.accelerationPedalStatus = object.accelerationPedalStatus ?? 0;
    return message;
  },
};

function createBasePositioningInfo(): PositioningInfo {
  return { header: undefined, latitude: 0, longitude: 0, height: 0, quality: 0, heading: 0, pitch: 0, roll: 0 };
}

export const PositioningInfo: MessageFns<PositioningInfo> = {
  encode(message: PositioningInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.latitude !== 0) {
      writer.uint32(21).float(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(29).float(message.longitude);
    }
    if (message.height !== 0) {
      writer.uint32(37).float(message.height);
    }
    if (message.quality !== 0) {
      writer.uint32(40).uint32(message.quality);
    }
    if (message.heading !== 0) {
      writer.uint32(53).float(message.heading);
    }
    if (message.pitch !== 0) {
      writer.uint32(61).float(message.pitch);
    }
    if (message.roll !== 0) {
      writer.uint32(69).float(message.roll);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositioningInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePositioningInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.latitude = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.longitude = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.height = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.quality = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.heading = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.pitch = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.roll = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<PositioningInfo>, I>>(base?: I): PositioningInfo {
    return PositioningInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PositioningInfo>, I>>(object: I): PositioningInfo {
    const message = createBasePositioningInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    message.height = object.height ?? 0;
    message.quality = object.quality ?? 0;
    message.heading = object.heading ?? 0;
    message.pitch = object.pitch ?? 0;
    message.roll = object.roll ?? 0;
    return message;
  },
};

function createBaseSteeringInfo(): SteeringInfo {
  return {
    header: undefined,
    steeringOverride: 0,
    steeringTorque: 0,
    steeringAngle: 0,
    steeringAngleRate: 0,
    steeringOffset: 0,
    controlState: 0,
    actuatorStatus: 0,
    errorCode: 0,
    responseTime: 0,
    actuationMode: 0,
    mrmStatus: 0,
  };
}

export const SteeringInfo: MessageFns<SteeringInfo> = {
  encode(message: SteeringInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.steeringOverride !== 0) {
      writer.uint32(16).int32(message.steeringOverride);
    }
    if (message.steeringTorque !== 0) {
      writer.uint32(29).float(message.steeringTorque);
    }
    if (message.steeringAngle !== 0) {
      writer.uint32(37).float(message.steeringAngle);
    }
    if (message.steeringAngleRate !== 0) {
      writer.uint32(45).float(message.steeringAngleRate);
    }
    if (message.steeringOffset !== 0) {
      writer.uint32(53).float(message.steeringOffset);
    }
    if (message.controlState !== 0) {
      writer.uint32(56).uint32(message.controlState);
    }
    if (message.actuatorStatus !== 0) {
      writer.uint32(64).uint32(message.actuatorStatus);
    }
    if (message.errorCode !== 0) {
      writer.uint32(72).uint32(message.errorCode);
    }
    if (message.responseTime !== 0) {
      writer.uint32(85).float(message.responseTime);
    }
    if (message.actuationMode !== 0) {
      writer.uint32(88).int32(message.actuationMode);
    }
    if (message.mrmStatus !== 0) {
      writer.uint32(96).int32(message.mrmStatus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SteeringInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSteeringInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.steeringOverride = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.steeringTorque = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.steeringAngle = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.steeringAngleRate = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.steeringOffset = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.controlState = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.actuatorStatus = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.errorCode = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.responseTime = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.actuationMode = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.mrmStatus = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SteeringInfo>, I>>(base?: I): SteeringInfo {
    return SteeringInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SteeringInfo>, I>>(object: I): SteeringInfo {
    const message = createBaseSteeringInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.steeringOverride = object.steeringOverride ?? 0;
    message.steeringTorque = object.steeringTorque ?? 0;
    message.steeringAngle = object.steeringAngle ?? 0;
    message.steeringAngleRate = object.steeringAngleRate ?? 0;
    message.steeringOffset = object.steeringOffset ?? 0;
    message.controlState = object.controlState ?? 0;
    message.actuatorStatus = object.actuatorStatus ?? 0;
    message.errorCode = object.errorCode ?? 0;
    message.responseTime = object.responseTime ?? 0;
    message.actuationMode = object.actuationMode ?? 0;
    message.mrmStatus = object.mrmStatus ?? 0;
    return message;
  },
};

function createBaseSteeringState(): SteeringState {
  return { header: undefined, steeringOverride: 0, steeringTorque: 0, steeringAngle: 0, steeringAngleRate: 0 };
}

export const SteeringState: MessageFns<SteeringState> = {
  encode(message: SteeringState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.steeringOverride !== 0) {
      writer.uint32(16).int32(message.steeringOverride);
    }
    if (message.steeringTorque !== 0) {
      writer.uint32(29).float(message.steeringTorque);
    }
    if (message.steeringAngle !== 0) {
      writer.uint32(37).float(message.steeringAngle);
    }
    if (message.steeringAngleRate !== 0) {
      writer.uint32(45).float(message.steeringAngleRate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SteeringState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSteeringState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.steeringOverride = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.steeringTorque = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.steeringAngle = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.steeringAngleRate = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SteeringState>, I>>(base?: I): SteeringState {
    return SteeringState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SteeringState>, I>>(object: I): SteeringState {
    const message = createBaseSteeringState();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.steeringOverride = object.steeringOverride ?? 0;
    message.steeringTorque = object.steeringTorque ?? 0;
    message.steeringAngle = object.steeringAngle ?? 0;
    message.steeringAngleRate = object.steeringAngleRate ?? 0;
    return message;
  },
};

function createBaseTimeInfo(): TimeInfo {
  return { header: undefined, year: 0, month: 0, day: 0, hour: 0, minute: 0, second: 0, millisecond: 0 };
}

export const TimeInfo: MessageFns<TimeInfo> = {
  encode(message: TimeInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.year !== 0) {
      writer.uint32(16).uint32(message.year);
    }
    if (message.month !== 0) {
      writer.uint32(24).uint32(message.month);
    }
    if (message.day !== 0) {
      writer.uint32(32).uint32(message.day);
    }
    if (message.hour !== 0) {
      writer.uint32(40).uint32(message.hour);
    }
    if (message.minute !== 0) {
      writer.uint32(48).uint32(message.minute);
    }
    if (message.second !== 0) {
      writer.uint32(56).uint32(message.second);
    }
    if (message.millisecond !== 0) {
      writer.uint32(64).uint32(message.millisecond);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TimeInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimeInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.year = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.month = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.day = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.hour = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.minute = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.second = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.millisecond = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TimeInfo>, I>>(base?: I): TimeInfo {
    return TimeInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimeInfo>, I>>(object: I): TimeInfo {
    const message = createBaseTimeInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.year = object.year ?? 0;
    message.month = object.month ?? 0;
    message.day = object.day ?? 0;
    message.hour = object.hour ?? 0;
    message.minute = object.minute ?? 0;
    message.second = object.second ?? 0;
    message.millisecond = object.millisecond ?? 0;
    return message;
  },
};

function createBaseTrafficLight(): TrafficLight {
  return {
    header: undefined,
    state: 0,
    stateProbability: 0,
    type: 0,
    isIts: false,
    intersectionId: 0,
    groupId: 0,
    endTime: 0,
    perceptionLevel: 0,
    trackId: 0,
    pose: undefined,
  };
}

export const TrafficLight: MessageFns<TrafficLight> = {
  encode(message: TrafficLight, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.state !== 0) {
      writer.uint32(16).int32(message.state);
    }
    if (message.stateProbability !== 0) {
      writer.uint32(29).float(message.stateProbability);
    }
    if (message.type !== 0) {
      writer.uint32(32).int32(message.type);
    }
    if (message.isIts !== false) {
      writer.uint32(40).bool(message.isIts);
    }
    if (message.intersectionId !== 0) {
      writer.uint32(48).int32(message.intersectionId);
    }
    if (message.groupId !== 0) {
      writer.uint32(56).int32(message.groupId);
    }
    if (message.endTime !== 0) {
      writer.uint32(69).float(message.endTime);
    }
    if (message.perceptionLevel !== 0) {
      writer.uint32(72).int32(message.perceptionLevel);
    }
    if (message.trackId !== 0) {
      writer.uint32(80).int32(message.trackId);
    }
    if (message.pose !== undefined) {
      PoseWithCovariance.encode(message.pose, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrafficLight {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrafficLight();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.stateProbability = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isIts = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.intersectionId = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.groupId = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.endTime = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.perceptionLevel = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.trackId = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.pose = PoseWithCovariance.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TrafficLight>, I>>(base?: I): TrafficLight {
    return TrafficLight.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrafficLight>, I>>(object: I): TrafficLight {
    const message = createBaseTrafficLight();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.state = object.state ?? 0;
    message.stateProbability = object.stateProbability ?? 0;
    message.type = object.type ?? 0;
    message.isIts = object.isIts ?? false;
    message.intersectionId = object.intersectionId ?? 0;
    message.groupId = object.groupId ?? 0;
    message.endTime = object.endTime ?? 0;
    message.perceptionLevel = object.perceptionLevel ?? 0;
    message.trackId = object.trackId ?? 0;
    message.pose = (object.pose !== undefined && object.pose !== null)
      ? PoseWithCovariance.fromPartial(object.pose)
      : undefined;
    return message;
  },
};

function createBaseTrafficLightArray(): TrafficLightArray {
  return { trafficLights: [] };
}

export const TrafficLightArray: MessageFns<TrafficLightArray> = {
  encode(message: TrafficLightArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.trafficLights) {
      TrafficLight.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrafficLightArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrafficLightArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.trafficLights.push(TrafficLight.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TrafficLightArray>, I>>(base?: I): TrafficLightArray {
    return TrafficLightArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrafficLightArray>, I>>(object: I): TrafficLightArray {
    const message = createBaseTrafficLightArray();
    message.trafficLights = object.trafficLights?.map((e) => TrafficLight.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTrafficSign(): TrafficSign {
  return { header: undefined, speedLimit: 0, schoolZone: false, tollgateLane: false, coneDetection: false };
}

export const TrafficSign: MessageFns<TrafficSign> = {
  encode(message: TrafficSign, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.speedLimit !== 0) {
      writer.uint32(16).uint32(message.speedLimit);
    }
    if (message.schoolZone !== false) {
      writer.uint32(24).bool(message.schoolZone);
    }
    if (message.tollgateLane !== false) {
      writer.uint32(32).bool(message.tollgateLane);
    }
    if (message.coneDetection !== false) {
      writer.uint32(40).bool(message.coneDetection);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrafficSign {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrafficSign();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.speedLimit = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.schoolZone = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.tollgateLane = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.coneDetection = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TrafficSign>, I>>(base?: I): TrafficSign {
    return TrafficSign.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrafficSign>, I>>(object: I): TrafficSign {
    const message = createBaseTrafficSign();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.speedLimit = object.speedLimit ?? 0;
    message.schoolZone = object.schoolZone ?? false;
    message.tollgateLane = object.tollgateLane ?? false;
    message.coneDetection = object.coneDetection ?? false;
    return message;
  },
};

function createBaseUserConfiguration(): UserConfiguration {
  return { header: undefined, maxSpeed: 0, maxSteeringTorque: 0, maxAcceleration: 0, maxDeceleration: 0, maxJerk: 0 };
}

export const UserConfiguration: MessageFns<UserConfiguration> = {
  encode(message: UserConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.maxSpeed !== 0) {
      writer.uint32(21).float(message.maxSpeed);
    }
    if (message.maxSteeringTorque !== 0) {
      writer.uint32(29).float(message.maxSteeringTorque);
    }
    if (message.maxAcceleration !== 0) {
      writer.uint32(37).float(message.maxAcceleration);
    }
    if (message.maxDeceleration !== 0) {
      writer.uint32(45).float(message.maxDeceleration);
    }
    if (message.maxJerk !== 0) {
      writer.uint32(53).float(message.maxJerk);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.maxSpeed = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.maxSteeringTorque = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.maxAcceleration = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.maxDeceleration = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.maxJerk = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<UserConfiguration>, I>>(base?: I): UserConfiguration {
    return UserConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserConfiguration>, I>>(object: I): UserConfiguration {
    const message = createBaseUserConfiguration();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.maxSpeed = object.maxSpeed ?? 0;
    message.maxSteeringTorque = object.maxSteeringTorque ?? 0;
    message.maxAcceleration = object.maxAcceleration ?? 0;
    message.maxDeceleration = object.maxDeceleration ?? 0;
    message.maxJerk = object.maxJerk ?? 0;
    return message;
  },
};

function createBaseVehicleGenericInfo(): VehicleGenericInfo {
  return {
    header: undefined,
    carType: 0,
    plateNumber: "",
    fuelType: 0,
    fuelState: 0,
    mileage: 0,
    projectCode: "",
    optionalCode: 0,
    licenseKey: "",
  };
}

export const VehicleGenericInfo: MessageFns<VehicleGenericInfo> = {
  encode(message: VehicleGenericInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.carType !== 0) {
      writer.uint32(16).int32(message.carType);
    }
    if (message.plateNumber !== "") {
      writer.uint32(26).string(message.plateNumber);
    }
    if (message.fuelType !== 0) {
      writer.uint32(32).int32(message.fuelType);
    }
    if (message.fuelState !== 0) {
      writer.uint32(45).float(message.fuelState);
    }
    if (message.mileage !== 0) {
      writer.uint32(48).uint64(message.mileage);
    }
    if (message.projectCode !== "") {
      writer.uint32(58).string(message.projectCode);
    }
    if (message.optionalCode !== 0) {
      writer.uint32(64).uint32(message.optionalCode);
    }
    if (message.licenseKey !== "") {
      writer.uint32(74).string(message.licenseKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VehicleGenericInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVehicleGenericInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.carType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.plateNumber = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.fuelType = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.fuelState = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.mileage = longToNumber(reader.uint64());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.projectCode = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.optionalCode = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.licenseKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<VehicleGenericInfo>, I>>(base?: I): VehicleGenericInfo {
    return VehicleGenericInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VehicleGenericInfo>, I>>(object: I): VehicleGenericInfo {
    const message = createBaseVehicleGenericInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.carType = object.carType ?? 0;
    message.plateNumber = object.plateNumber ?? "";
    message.fuelType = object.fuelType ?? 0;
    message.fuelState = object.fuelState ?? 0;
    message.mileage = object.mileage ?? 0;
    message.projectCode = object.projectCode ?? "";
    message.optionalCode = object.optionalCode ?? 0;
    message.licenseKey = object.licenseKey ?? "";
    return message;
  },
};

function createBaseWheelInfo(): WheelInfo {
  return {
    header: undefined,
    wheelSpeedRr: 0,
    wheelSpeedRl: 0,
    wheelSpeedFr: 0,
    wheelSpeedFl: 0,
    wheelPulseStatusRr: false,
    wheelPulseStatusRl: false,
    wheelPulseStatusFr: false,
    wheelPulseStatusFl: false,
    wheelPulseRr: 0,
    wheelPulseRl: 0,
    wheelPulseFr: 0,
    wheelPulseFl: 0,
    wheelDirRr: 0,
    wheelDirRl: 0,
    wheelDirFr: 0,
    wheelDirFl: 0,
  };
}

export const WheelInfo: MessageFns<WheelInfo> = {
  encode(message: WheelInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.wheelSpeedRr !== 0) {
      writer.uint32(21).float(message.wheelSpeedRr);
    }
    if (message.wheelSpeedRl !== 0) {
      writer.uint32(29).float(message.wheelSpeedRl);
    }
    if (message.wheelSpeedFr !== 0) {
      writer.uint32(37).float(message.wheelSpeedFr);
    }
    if (message.wheelSpeedFl !== 0) {
      writer.uint32(45).float(message.wheelSpeedFl);
    }
    if (message.wheelPulseStatusRr !== false) {
      writer.uint32(48).bool(message.wheelPulseStatusRr);
    }
    if (message.wheelPulseStatusRl !== false) {
      writer.uint32(56).bool(message.wheelPulseStatusRl);
    }
    if (message.wheelPulseStatusFr !== false) {
      writer.uint32(64).bool(message.wheelPulseStatusFr);
    }
    if (message.wheelPulseStatusFl !== false) {
      writer.uint32(72).bool(message.wheelPulseStatusFl);
    }
    if (message.wheelPulseRr !== 0) {
      writer.uint32(80).uint32(message.wheelPulseRr);
    }
    if (message.wheelPulseRl !== 0) {
      writer.uint32(88).uint32(message.wheelPulseRl);
    }
    if (message.wheelPulseFr !== 0) {
      writer.uint32(96).uint32(message.wheelPulseFr);
    }
    if (message.wheelPulseFl !== 0) {
      writer.uint32(104).uint32(message.wheelPulseFl);
    }
    if (message.wheelDirRr !== 0) {
      writer.uint32(112).int32(message.wheelDirRr);
    }
    if (message.wheelDirRl !== 0) {
      writer.uint32(120).int32(message.wheelDirRl);
    }
    if (message.wheelDirFr !== 0) {
      writer.uint32(128).int32(message.wheelDirFr);
    }
    if (message.wheelDirFl !== 0) {
      writer.uint32(136).int32(message.wheelDirFl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WheelInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWheelInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.wheelSpeedRr = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.wheelSpeedRl = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.wheelSpeedFr = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.wheelSpeedFl = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.wheelPulseStatusRr = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.wheelPulseStatusRl = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.wheelPulseStatusFr = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.wheelPulseStatusFl = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.wheelPulseRr = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.wheelPulseRl = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.wheelPulseFr = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.wheelPulseFl = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.wheelDirRr = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.wheelDirRl = reader.int32() as any;
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.wheelDirFr = reader.int32() as any;
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.wheelDirFl = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<WheelInfo>, I>>(base?: I): WheelInfo {
    return WheelInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WheelInfo>, I>>(object: I): WheelInfo {
    const message = createBaseWheelInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.wheelSpeedRr = object.wheelSpeedRr ?? 0;
    message.wheelSpeedRl = object.wheelSpeedRl ?? 0;
    message.wheelSpeedFr = object.wheelSpeedFr ?? 0;
    message.wheelSpeedFl = object.wheelSpeedFl ?? 0;
    message.wheelPulseStatusRr = object.wheelPulseStatusRr ?? false;
    message.wheelPulseStatusRl = object.wheelPulseStatusRl ?? false;
    message.wheelPulseStatusFr = object.wheelPulseStatusFr ?? false;
    message.wheelPulseStatusFl = object.wheelPulseStatusFl ?? false;
    message.wheelPulseRr = object.wheelPulseRr ?? 0;
    message.wheelPulseRl = object.wheelPulseRl ?? 0;
    message.wheelPulseFr = object.wheelPulseFr ?? 0;
    message.wheelPulseFl = object.wheelPulseFl ?? 0;
    message.wheelDirRr = object.wheelDirRr ?? 0;
    message.wheelDirRl = object.wheelDirRl ?? 0;
    message.wheelDirFr = object.wheelDirFr ?? 0;
    message.wheelDirFl = object.wheelDirFl ?? 0;
    return message;
  },
};

function createBaseWheelState(): WheelState {
  return {
    header: undefined,
    wheelSpeedRr: 0,
    wheelSpeedRl: 0,
    wheelSpeedFr: 0,
    wheelSpeedFl: 0,
    wheelPulseStatusRr: false,
    wheelPulseStatusRl: false,
    wheelPulseStatusFr: false,
    wheelPulseStatusFl: false,
    wheelPulseRr: 0,
    wheelPulseRl: 0,
    wheelPulseFr: 0,
    wheelPulseFl: 0,
    wheelDirRr: 0,
    wheelDirRl: 0,
    wheelDirFr: 0,
    wheelDirFl: 0,
  };
}

export const WheelState: MessageFns<WheelState> = {
  encode(message: WheelState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.wheelSpeedRr !== 0) {
      writer.uint32(21).float(message.wheelSpeedRr);
    }
    if (message.wheelSpeedRl !== 0) {
      writer.uint32(29).float(message.wheelSpeedRl);
    }
    if (message.wheelSpeedFr !== 0) {
      writer.uint32(37).float(message.wheelSpeedFr);
    }
    if (message.wheelSpeedFl !== 0) {
      writer.uint32(45).float(message.wheelSpeedFl);
    }
    if (message.wheelPulseStatusRr !== false) {
      writer.uint32(48).bool(message.wheelPulseStatusRr);
    }
    if (message.wheelPulseStatusRl !== false) {
      writer.uint32(56).bool(message.wheelPulseStatusRl);
    }
    if (message.wheelPulseStatusFr !== false) {
      writer.uint32(64).bool(message.wheelPulseStatusFr);
    }
    if (message.wheelPulseStatusFl !== false) {
      writer.uint32(72).bool(message.wheelPulseStatusFl);
    }
    if (message.wheelPulseRr !== 0) {
      writer.uint32(80).uint32(message.wheelPulseRr);
    }
    if (message.wheelPulseRl !== 0) {
      writer.uint32(88).uint32(message.wheelPulseRl);
    }
    if (message.wheelPulseFr !== 0) {
      writer.uint32(96).uint32(message.wheelPulseFr);
    }
    if (message.wheelPulseFl !== 0) {
      writer.uint32(104).uint32(message.wheelPulseFl);
    }
    if (message.wheelDirRr !== 0) {
      writer.uint32(112).int32(message.wheelDirRr);
    }
    if (message.wheelDirRl !== 0) {
      writer.uint32(120).int32(message.wheelDirRl);
    }
    if (message.wheelDirFr !== 0) {
      writer.uint32(128).int32(message.wheelDirFr);
    }
    if (message.wheelDirFl !== 0) {
      writer.uint32(136).int32(message.wheelDirFl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WheelState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWheelState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.wheelSpeedRr = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.wheelSpeedRl = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.wheelSpeedFr = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.wheelSpeedFl = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.wheelPulseStatusRr = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.wheelPulseStatusRl = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.wheelPulseStatusFr = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.wheelPulseStatusFl = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.wheelPulseRr = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.wheelPulseRl = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.wheelPulseFr = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.wheelPulseFl = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.wheelDirRr = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.wheelDirRl = reader.int32() as any;
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.wheelDirFr = reader.int32() as any;
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.wheelDirFl = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<WheelState>, I>>(base?: I): WheelState {
    return WheelState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WheelState>, I>>(object: I): WheelState {
    const message = createBaseWheelState();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.wheelSpeedRr = object.wheelSpeedRr ?? 0;
    message.wheelSpeedRl = object.wheelSpeedRl ?? 0;
    message.wheelSpeedFr = object.wheelSpeedFr ?? 0;
    message.wheelSpeedFl = object.wheelSpeedFl ?? 0;
    message.wheelPulseStatusRr = object.wheelPulseStatusRr ?? false;
    message.wheelPulseStatusRl = object.wheelPulseStatusRl ?? false;
    message.wheelPulseStatusFr = object.wheelPulseStatusFr ?? false;
    message.wheelPulseStatusFl = object.wheelPulseStatusFl ?? false;
    message.wheelPulseRr = object.wheelPulseRr ?? 0;
    message.wheelPulseRl = object.wheelPulseRl ?? 0;
    message.wheelPulseFr = object.wheelPulseFr ?? 0;
    message.wheelPulseFl = object.wheelPulseFl ?? 0;
    message.wheelDirRr = object.wheelDirRr ?? 0;
    message.wheelDirRl = object.wheelDirRl ?? 0;
    message.wheelDirFr = object.wheelDirFr ?? 0;
    message.wheelDirFl = object.wheelDirFl ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
